import React from 'react'
import {useDrag} from 'react-dnd'
import {TurnoRecord} from "@commons/mapping/TurnoRecord";
import {BadgeTurno} from "../pianificazione/comps/BadgeTurno";
import TooltipEx from "@components/Tooltip";
import Badge from "@components/Badge";
import {ItemTypes, Tool} from "../../../core/DnDItemTypes";

interface DropResult {
    name: string,
}

const Turno4Drag: React.FC<{
    elemento: TurnoRecord,
    type: string,
    //setElementiSelezionabili: React.Dispatch<React.SetStateAction<ElementoRMLSelezionabileRecord[]>>,
    //setElementiSelezionati: React.Dispatch<React.SetStateAction<ElementoRMLSelezionabileRecord[]>>
}> = ({elemento, type,}) => {

    const [{isDragging}, drag] = useDrag(() => ({
        type: type,
        item: elemento,
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult<DropResult>()
            if (item && dropResult) {
                //alert(`You dropped ${item.elemento.descrizione} into ${dropResult.name}!`)
                const elemento = item;//.elemento;
                let selezionato;
                /*if (type === ItemTypes.TURNO) {
                    console.log("abilito voce", item.descrizione);
                    selezionato = true;
                } else {
                    console.log("disabilito voce", item.descrizione);
                    selezionato = false;
                }*/
                /*updateTrigger({...item, selezionato})
                    .unwrap()
                    .then(() => {
                        setElementiSelezionabili((v) => v.filter(obj => obj.codElemento !== elemento.codElemento));
                        setElementiSelezionati((v) => v.concat([elemento]));
                    })
                    .catch((error: MutationError) => {
                        // @ts-ignore
                        const message = error.data.message;
                        toastAsError(message);
                    })*/
            }
        },

        collect: monitor => ({
            isDragging: !!monitor.isDragging(),
        }),
    }))

    return (
        <span ref={drag} className={`text-sm text-center cursor-move ${isDragging ? 'opacity-50' : 'opacity-100'}`}>
            <TooltipEx tooltip={elemento.descrizione + ` [#${elemento.codTurno}]`}>
                <BadgeTurno elemento={elemento}/>
            </TooltipEx>
        </span>
    )
}
export const TurnoTools4Drag: React.FC<{
    type: string,
    //setElementiSelezionabili: React.Dispatch<React.SetStateAction<ElementoRMLSelezionabileRecord[]>>,
    //setElementiSelezionati: React.Dispatch<React.SetStateAction<ElementoRMLSelezionabileRecord[]>>
}> = ({type,}) => {
    let tool: Tool;
    switch (type) {
        case ItemTypes.TURNO_PENCIL:
            tool = {type, name: 'pencil', icon: 'pencil', tooltip: 'Trascina la matita sulla giornata per la quale si intende modificare il previsto'};
            break;
        case ItemTypes.TURNO_ERASER:
            tool = {type, name: 'eraser', icon: 'eraser', tooltip: 'Trascina la gomma sulla giornata per la quale si intende ripristinare il previsto originale'};
            break;
        default:
            tool = {type, name: '???', icon: 'pencil', tooltip: '???'}
            break;
    }

    const [{isDragging}, drag] = useDrag(() => ({
        type: type,
        item: tool,
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult<DropResult>()
            if (item && dropResult) {
            }
        },

        collect: monitor => ({
            isDragging: !!monitor.isDragging(),
        }),
    }))

    return (
        <span ref={drag} className={`text-sm text-center cursor-move ${isDragging ? 'opacity-50' : 'opacity-100'}`}>
            <TooltipEx tooltip={tool.tooltip}>
                <Badge spanClass="!bg-yellow-100 !text-yellow-800 border border-gray-500" className="rounded-full px-1.5 py-0.5" label="" icon={tool.icon}></Badge>
            </TooltipEx>
        </span>
    )
}

export default Turno4Drag